import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { FreetextToolService } from '../../freetext-tool/freetext-tool.service';

@AddinExecute({
  name: 'JournalToolsSetup'
})
@Injectable()
export class JournalToolsSetupService extends Execute {
  constructor(
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private freetextTool: FreetextToolService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => {
        const toolsEnabled: boolean = this.profileReader.getComponentConfig('SingleCallcardJournal', 'tools', false);
        if (toolsEnabled) {
          this.freetextTool.registerTool();
        }
      });
  }
}
